export const DEFAULT_RADIUS = 2500; // Default radius in meters
export const DEFAULT_NUMBER_OF_POIS = 30; // Default number of points of interest to fetch
export const DEFAULT_MIN_ZOOM = 6; // Default minimum zoom level for the map
export const DEFAULT_MAX_ZOOM = 17; // Default maximum zoom level for the map
export const DEFAULT_TRAVEL_MODE = "walking"; // Default travel mode for commute calculations
export const DIRECTIONS_PATH_COLOR = "#006AFF"; // Color for the directions path on the map
export const METERS_TO_YARDS_CONVERSION_FACTOR = 1.0936132983; // Conversion factor from meters to yards
export const YARDS_PER_MILE = 1760; // Number of yards in a mile
export const METERS_PER_KILOMETER = 1000; // Number of meters in a kilometer

export const MAP_PADDING = {
  desktop: {
    top: 75,
    bottom: 75,
    left: 375,
    right: 75,
  },
  mobile: {
    top: 75,
    bottom: 50,
    left: 50,
    right: 50,
  },
};
